import type { DeepKeys, DeepValue, Updater } from "@tanstack/react-form";
import type { z } from "zod";

import type { FieldInputProps } from "@/components/form/field-input";
import LabeledField from "@/components/form/labeled-field";
import { PhoneInput } from "@/components/form/phone-input";
import { getOnChangeFromZod } from "@/utils/form";

const FieldInputPhone = <
  TFormData,
  TName extends DeepKeys<TFormData> & string,
  TSchema extends z.ZodType<TFormData> | undefined,
  TData extends DeepValue<TFormData, TName> = DeepValue<TFormData, TName>,
>({
  Field,
  name,
  schema,
  label,
  validators,
  labelProps,
  gridRow,
  ...props
}: FieldInputProps<TFormData, TName, TSchema, TData>) => {
  return (
    <Field
      name={name}
      validators={{
        onChange: schema ? getOnChangeFromZod(schema, name) : undefined,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(validators as any), // unsolved typing issue
      }}
      children={(field) => {
        return (
          <LabeledField
            label={label}
            fieldName={field.name.toString()}
            errors={field.state.meta.errors}
            required={props.required}
            gridRow={gridRow}
            {...labelProps}
          >
            <PhoneInput
              {...props}
              value={
                field.state.value && typeof field.state.value !== "boolean"
                  ? (field.state.value as string | undefined)
                  : undefined
              }
              onChange={
                field.handleChange as (
                  updater: Updater<string | undefined>
                ) => void
              }
            />
          </LabeledField>
        );
      }}
    />
  );
};

export default FieldInputPhone;
